import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { KEYS_APPSTORAGE, NavigationService, AppStorageService, ResourceService, ConfirmDialogService, AlertService } from 'sce-core';
import { gb } from '../../growthbook';

@Injectable()
export class UnifiedNavigationService extends NavigationService {

  constructor(
    router: Router,
    http: HttpClient,
    resourceService: ResourceService,
    confirmDialogService: ConfirmDialogService,
    activatedRoute: ActivatedRoute,
    titleService: Title,
    alertService: AlertService,
    appStorageService: AppStorageService
  ) {
    super(router, http, resourceService, confirmDialogService, activatedRoute, titleService, alertService, appStorageService, null);
  }

  public setApplicationUrlNavigationBase(applicationToNavigate: string): void {
    this.setGbAttributes(applicationToNavigate);
    super.setApplicationUrlNavigationBase(applicationToNavigate);
    if (gb.isOn('angular18-enabled-v0')) {
      this.urlNavigationKey = `/preview${this.urlNavigationKey}`;
    }
    else if (gb.isOn('unified-wms-v0')) {
      this.urlNavigationKey = `/unified${this.urlNavigationKey}`;
    }
  }

  public navigateByUrl(url: string, skipLocationChange?: boolean, menuId?: string): boolean {
    if(this.navigateToPreview(url)) {
      try {
        window.history.replaceState(null, '', url);
        window.location.replace(`${window.location.origin}/preview${url}`);
        return true;
      } catch (error) {
        console.error('Navigation error:', error);
        return false;
      }
    }
    else if (this.navigateToUnifiedApplication(url)) {
      try {
        window.history.replaceState(null, '', url);
        window.location.replace(`${window.location.origin}/unified${url}`);
        return true;
      } catch (error) {
        console.error('Navigation error:', error);
        return false;
      }
    }
    return super.navigateByUrl(url, skipLocationChange, menuId);
  }

  public navigateToUnifiedApplication(url: string): boolean {
    const module = url.split('/')[2];
    if (!module) { // not a valid url for unified app
      return false;
    }
    this.setGbAttributes(module);
    return gb.isOn('unified-wms-v0');
  }

  public navigateToPreview(url: string): boolean {
    const module = url.split('/')[2];
    if (!module) { // not a valid url
      return false;
    }
    this.setGbAttributes(module);
    return gb.isOn('angular18-enabled-v0');
  }

  setGbAttributes(module: string) {
    const userInfo = this.appStorageService.getItem(KEYS_APPSTORAGE.USER_INFO);
    const existingAttributes = gb.getAttributes();
    gb.setAttributes({
      ...existingAttributes,
      module,
      email: userInfo.emailAddress,
      country: userInfo.defaultCountry.toString(),
    });
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/core/unified-navigation.service.ts